module.exports = __webpack_public_path__ + "img/waves-grey-background.f64204fa.png";